import { post } from "@insite/client-framework/Services/ApiService";

const billingDisputeUrl = "/api/v2/CustomerServiceForms/SubmitBillingDisputeForm";
const creditAnalystUrl = "/api/v2/CustomerServiceForms/SubmitContactCreditAnalystForm";

export interface DisputeParameters {
    accountNumber?: string;
    firstName?: string;
    lastName?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    email?: string;
    fax?: string;
    phone?: string;
    extension?: string;
    purchaseOrderNumber?: string;
    invoiceNumber?: string;
    disputeReason?: string;
    description?: string;
}

export interface CreditAnalystParameters {
    accountNumber?: string;
    firstName?: string;
    lastName?: string;
    title?: string;
    email?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    phoneNumber?: string;
    phoneExtension?: string;
    faxNumber?: string;
    creditQuestion?: string;
}

export const sendBillingDispute = async (parameters: DisputeParameters) => {
    const response = await post<DisputeParameters>(billingDisputeUrl, parameters);
    return response;
};

export const sendContactCreditAnalyst = async (parameters: CreditAnalystParameters) => {
    const response = await post<CreditAnalystParameters>(creditAnalystUrl, parameters);
    return response;
};
